import { createContext, useContext } from 'react';
var initialState = {};
export var rovoMentionProviderDefaults = initialState;
var rovoMentionProvider = /*#__PURE__*/createContext(initialState);
export var RovoMentionProvider = rovoMentionProvider.Provider;
export var useRovoMentionProvider = function useRovoMentionProvider() {
  return useContext(rovoMentionProvider);
};